import { DeviceControlDAO } from '../../../../../../data/DeviceControlDAO';
import { commonDataAccess } from '../../data/dataAccessObject';
export const ondemandSchedulerDAO = {
    ...commonDataAccess,
    getProgrammeContext: DeviceControlDAO.device.control.programme.ondemand.getContext,
};
